var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircuitBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60 19h-1v-5c0-1.654-1.346-3-3-3h-52c-1.654 0-3 1.346-3 3v36c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-2c0-1.654 1.346-3 3-3s3 1.346 3 3v2c0 1.654 1.346 3 3 3h30c1.654 0 3-1.346 3-3v-5h1c1.654 0 3-1.346 3-3v-20c0-1.654-1.346-3-3-3zm1 23c0 .551-.448 1-1 1h-3v7c0 .551-.448 1-1 1h-30c-.552 0-1-.449-1-1v-2c0-2.757-2.243-5-5-5s-5 2.243-5 5v2c0 .551-.448 1-1 1h-10c-.552 0-1-.449-1-1v-36c0-.551.448-1 1-1h52c.552 0 1 .449 1 1v7h3c.552 0 1 .449 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 49h8v-6h-8zm2-4h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 49h8v-6h-8zm2-4h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 49h8v-6h-8zm2-4h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 49h8v-6h-8zm2-4h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 39v-4h2v4h2v-4h2v-2h4v-2h-4v-2h4v-2h-4v-2h4v-2h-4v-2h-2v-4h-2v4h-2v-4h-2v4h-2v-4h-2v4h-2v-4h-2v4h-2v2h-4v2h4v2h-4v2h4v2h-4v2h4v2h2v4h2v-4h2v4h2v-4h2v4zm-10-16h14v10h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 25h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 25h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 29h10v2h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 41h2c1.103 0 2-.897 2-2v-22c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v22c0 1.103.897 2 2 2zm0-24h2l.001 22h-2.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 15h-2c-1.103 0-2 .897-2 2v22c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-22c0-1.103-.897-2-2-2zm-2 24v-22h2l.001 22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 23c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 33c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 15h2v2h-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuitBoard);
export default __webpack_public_path__ + "static/media/circuit-board.64d5805b13bb6b3a660983259b3535ca.svg";
export { ForwardRef as ReactComponent };